import { ConfigFn } from '@config/types'

const config = (({ staticAssetPageUrl, staticPageUrlSuffix }) =>
  ({
    staticPageUrl: `${staticAssetPageUrl}/vimeo${staticPageUrlSuffix}?url=`,
  }) as const) satisfies ConfigFn

export default config
